(function () {
  'use strict';

  var CACHE_TTL_MS = 10 * 60 * 1000;
  var MAX_PAGES = 4;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var containers = document.querySelectorAll('[data-dollusional-episodes]');
    for (var i = 0; i < containers.length; i++) {
      setup(containers[i]);
    }
  }

  function setup(container) {
    var target = container.querySelector('[data-dollusional-auto]');
    if (!target) return;

    var apiKey = (container.getAttribute('data-api-key') || '').trim();
    var channelId = (container.getAttribute('data-channel-id') || '').trim();
    var sort = container.getAttribute('data-sort') === 'newest' ? 'newest' : 'oldest';
    var channelUrl = (container.getAttribute('data-channel-url') || '').trim();

    var limit = parseInt(container.getAttribute('data-max'), 10);
    if (isNaN(limit) || limit < 1) limit = 50;
    if (limit > 50) limit = 50;

    if (!apiKey || !channelId) {
      showFallback(container, target, channelUrl);
      return;
    }

    var cacheKey = 'dollusional_episodes_' + channelId;
    var cached = readCache(cacheKey);
    if (cached) {
      var shown = render(target, cached, sort, limit);
      if (shown === 0) showFallback(container, target, channelUrl);
      return;
    }

    fetchEpisodes(apiKey, uploadsPlaylistId(channelId), limit)
      .then(function (episodes) {
        writeCache(cacheKey, episodes);
        var count = render(target, episodes, sort, limit);
        if (count === 0) showFallback(container, target, channelUrl);
      })
      .catch(function () {
        showFallback(container, target, channelUrl);
      });
  }

  function uploadsPlaylistId(channelId) {
    if (channelId.indexOf('UC') === 0) {
      return 'UU' + channelId.slice(2);
    }
    return channelId;
  }

  function fetchEpisodes(apiKey, playlistId, needed) {
    var collected = [];

    function page(token, pagesLeft) {
      var url = 'https://www.googleapis.com/youtube/v3/playlistItems' +
        '?part=snippet&maxResults=50' +
        '&playlistId=' + encodeURIComponent(playlistId) +
        '&key=' + encodeURIComponent(apiKey);
      if (token) {
        url += '&pageToken=' + encodeURIComponent(token);
      }

      return fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('YouTube API responded ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var items = data.items || [];
          for (var i = 0; i < items.length; i++) {
            var sn = items[i].snippet;
            if (!sn || !sn.resourceId || !sn.resourceId.videoId) continue;
            if (sn.title === 'Private video' || sn.title === 'Deleted video') continue;
            collected.push({
              videoId: sn.resourceId.videoId,
              title: sn.title,
              publishedAt: sn.publishedAt
            });
          }
          if (collected.length < needed && data.nextPageToken && pagesLeft > 1) {
            return page(data.nextPageToken, pagesLeft - 1);
          }
          return collected;
        });
    }

    return page(null, MAX_PAGES);
  }

  function render(target, episodes, sort, limit) {
    var sorted = episodes.slice().sort(function (a, b) {
      return new Date(b.publishedAt) - new Date(a.publishedAt);
    });
    var shown = sorted.slice(0, limit);
    if (sort === 'oldest') shown.reverse();

    target.innerHTML = '';
    for (var i = 0; i < shown.length; i++) {
      target.appendChild(buildEpisode(shown[i]));
    }
    return shown.length;
  }

  function buildEpisode(ep) {
    var article = document.createElement('article');
    article.className = 'dollusional-episode';

    var frame = document.createElement('div');
    frame.className = 'dollusional-episode__frame';

    var iframe = document.createElement('iframe');
    iframe.className = 'dollusional-episode__iframe';
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(ep.videoId);
    iframe.title = ep.title || 'Dollusional episode';
    iframe.loading = 'lazy';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    frame.appendChild(iframe);
    article.appendChild(frame);

    if (ep.title) {
      var title = document.createElement('h2');
      title.className = 'dollusional-episode__title';
      title.textContent = ep.title;
      article.appendChild(title);
    }

    return article;
  }

  function showFallback(container, target, channelUrl) {
    var fallback = container.querySelector('[data-dollusional-fallback]');
    if (fallback) {
      fallback.removeAttribute('hidden');
      return;
    }
    if (!channelUrl) return;

    var notice = document.createElement('p');
    notice.className = 'dollusional__episodes-notice';
    var link = document.createElement('a');
    link.href = channelUrl;
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = 'Watch every episode on YouTube';
    notice.appendChild(link);
    target.appendChild(notice);
  }

  function readCache(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.t || !parsed.e || !parsed.e.length) return null;
      if (Date.now() - parsed.t > CACHE_TTL_MS) return null;
      return parsed.e;
    } catch (err) {
      return null;
    }
  }

  function writeCache(key, episodes) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), e: episodes }));
    } catch (err) {
      /* storage unavailable — skip caching */
    }
  }
})();
